import { FiltersFormValues } from '@common/types/person.types'
import { createContext, Dispatch, PropsWithChildren, SetStateAction, useContext, useMemo, useState } from 'react'

type TraineeListFilters = {
	filters: FiltersFormValues
	companyLabel: string
	setFilters: Dispatch<SetStateAction<FiltersFormValues>>
	setCompanyLabel: Dispatch<SetStateAction<string>>
}

const TraineeListFiltersContext = createContext<TraineeListFilters>({
	filters: {
		query: '',
		company: '',
		course: '',
		start: undefined,
		end: undefined
	},
	companyLabel: '',
	setFilters: () => undefined,
	setCompanyLabel: () => undefined
})

export const TraineeListFiltersProvider = ({ children }: PropsWithChildren) => {
	const [filters, setFilters] = useState<FiltersFormValues>({
		query: '',
		company: '',
		course: '',
		start: undefined,
		end: undefined
	})

	const [companyLabel, setCompanyLabel] = useState<string>('')

	const value = useMemo((): TraineeListFilters => ({
		filters,
		companyLabel,
		setFilters,
		setCompanyLabel
	}), [filters, companyLabel])

	return (
		<TraineeListFiltersContext.Provider value={value}>
			{children}
		</TraineeListFiltersContext.Provider>
	)
}

export const useTraineeListFilters = () => {
	const context = useContext(TraineeListFiltersContext)
	if (!context) throw new Error('useTraineeListFilters must be used within a TraineeListFiltersProvider')
	return context
}
